import { api } from "./api";

export const obtenerEstudiantes = async (page = 0, size) => {
  const { data } = await api.get("/usuario/all", { params: { page, size } });
  return data;
};

export const obtenerEstudiantePorId = async (cif) => {
  return api.get("/usuario/findByCif", { params: { cif } });
};

export const actualizarInfoEstudiante = async (estudiante) => {
  return api.put("/usuario/update", estudiante);
};

export const cambiarFotoPerfilEstudiante = async (cif, imagenBase64) => {
  return api.put(`/usuario/changeProfilePicture/${cif}`, imagenBase64, {
    headers: { "Content-Type": "text/plain;charset=utf-8" }, // opcionalmente añade charset
  });
};

export const inhabilitarEstudiante = async (cif) => {
  const { data } = await api.put(`/usuario/inhabilitar/${cif}`, {});
  return data;
};

export const habilitarEstudiante = async (cif) => {
  const { data } = await api.put(`/usuario/habilitar/${cif}`, {});
  return data;
};

export const verificarSolvenciaEstudiante = async (cif) => {
  const { data } = await api.get("/usuario/verificarSolvencia", { params: { cif } });
  return data;
};
